var FeedbackProvider = /** @class */ (function () {
    function FeedbackProvider() {
    }
    FeedbackProvider.openFeedback = function (event) {
        OOo.inlineFeedbackShow(event);
    };
    return FeedbackProvider;
}());
export { FeedbackProvider };
//# sourceMappingURL=feedback-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/feedback-provider.js
// module id = 2235
// module chunks = 8